import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import z from "zod";
import { assetInstanceQueryOptions } from "@/services/asset";

/**
 * Thin related-Asset layout under an org Asset → Record Assets tab.
 * Drawer chrome lives in the pathless `_drawer` layout.
 */
export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/assets/(asset)/$assetId/workspace/records/$recordId/workspace/assets/$relatedAssetId",
)({
	params: {
		parse: (params) => ({
			relatedAssetId: z.string().parse(params.relatedAssetId),
		}),
	},
	beforeLoad: ({ location, params }) => {
		const normalized = location.pathname.replace(/\/$/, "");
		const exactRoot = normalized.endsWith(
			`/workspace/assets/${params.relatedAssetId}`,
		);
		if (exactRoot) {
			const q =
				typeof location.search === "object" &&
				location.search &&
				"q" in location.search &&
				typeof (location.search as { q?: unknown }).q === "string"
					? (location.search as { q: string }).q
					: undefined;
			throw redirect({
				to: "/web/$orgId/assets/$assetId/workspace/records/$recordId/workspace/assets/$relatedAssetId/details",
				params: {
					orgId: params.orgId,
					assetId: params.assetId,
					recordId: params.recordId,
					relatedAssetId: params.relatedAssetId,
				},
				search: { q },
			});
		}
	},
	loader: ({ context, params }) => {
		void context.queryClient.prefetchQuery(
			assetInstanceQueryOptions.detail(params.relatedAssetId, {
				organizationId: params.orgId,
			}),
		);
	},
	component: RelatedAssetIdLayout,
});

function RelatedAssetIdLayout() {
	return <Outlet />;
}
